import { rdb } from './initialise'
import { ref, set, update, push, remove } from 'firebase/database'

export const getPositions = () => {
    const posRef = ref(rdb, 'positions')
    return posRef
}

export const addPosition = (position) => {
    const posRef = ref(rdb, 'positions')
    const newPosRef = push(posRef)
    return set(newPosRef, {
        id: newPosRef.key,
        name: position.name,
        short_name: position.short_name,
        wage: Number(position.wage)
    })
}

export const updatePosition = (id, data) => {
    const posRef = ref(rdb, `positions/${id}`)
    return update(posRef, {
        name: data.name,
        short_name: data.short_name,
        wage: Number(data.wage)
    })
}

export const deletePosition = (id) => {
    const posRef = ref(rdb, `positions/${id}`)
    return remove(posRef)
}
